<div class="content_container">
    <div>
        <div class="logo_container">
            <img src="../../../assets/AMADEO LOGO 2.png" class="logo">
        </div>
        <div class="page_title">PEOPLE ACCESS</div>
    </div>
    <div class="products_container">
        <div class="product_item"> 
            <!--  disabled for .com-->
            <a (click)="routeToIntegraCloud()">
                <div>
                    <div class="img_container residential">
                        <img src="../../../assets/residential2.png" alt="Residential" class="product_img img1">
                    </div>
                </div>
                <div>
                    <div class="prod_title">RESIDENTIAL</div>
                    <div class="prod_subtitle">residential</div>
                </div>
            </a>
        </div>
        <div class="product_item"> 
            <!-- disabled for .com -->
            <a (click)="routeToIntegraCloud()">
                <div>
                    <div class="img_container amadeo_access_control">
                        <img src="../../../assets/access control2.png" alt="AMADEO Access Control" class="product_img img1">
                    </div>
                </div>
                <div>
                    <div class="prod_title">ACCESS CONTROL</div>
                    <div class="prod_subtitle">remote security</div>
                </div>
            </a>
        </div>
        <div class="product_item">
            <a (click)="routeToIntegraCloud()">
                <div>
                    <div class="img_container hospitality">
                        <img src="../../../assets/Hospitality.png" alt="HOSPITALITY" class="product_img img2">
                    </div>
                </div>
                <div>
                    <div class="prod_title">HOSPITALITY</div>
                    <div class="prod_subtitle">convenient control</div>
                </div>
            </a>
        </div>
        <div class="product_item">
            <!-- disabled for .com -->
            <a (click)="routeToFreeflexPlanner()">
                <div style="padding:0;margin:0">
                    <div class="img_container freeflex">
                        <img src="../../../assets/freeflex2.png" alt="FREEFLEX PLANNER" class="product_img img4">
                    </div>
                </div>
                <div>
                    <div class="prod_title">FREEFLEX PLANNER</div>
                    <div class="prod_subtitle">mechanical security</div>
                </div>
            </a>
        </div>
        
        <div class="product_item grey">
            <!-- grey -->
            <a (click)="openAbooking()">
                <div style="padding:0;margin:0">
                    <div class="img_container abooking">
                        <img src="../../../assets/Abook.png" alt="ABOOKING" class="product_img">
                    </div>
                </div>
                <div>
                    <div class="prod_title">A-BOOKING</div>
                    <div class="prod_subtitle">BPO - Book Pay Open</div>
                </div>
            </a>
        </div>
        <div class="product_item">
            <!-- disabled on .com -->
            <a (click)="routeToMobileReception()">
                <div style="padding:0;margin:0">
                    <div class="img_container mobile_reception">
                        <img src="../../../assets/mobile-reception.png" alt="CLOUD RECEPTION" class="product_img">
                    </div>
                </div>
                <div>
                    <!-- <div class="prod_title">CLOUD RECEPTION</div> -->
                    <div class="prod_title">MOBILE RECEPTION</div>
                    <div class="prod_subtitle">Reception control</div>
                </div>
            </a>
        </div>
        <div class="product_item">
            <!--  -->
            <a (click)="routeToAOSWithDirection(aosRouteDirection.SoftwareApp)">
                <div style="padding:0;margin:0">
                    <div class="img_container app_service">
                        <img src="../../../assets/app-service.png" alt="app service" class="product_img">
                    </div>
                </div>
                <div>
                    <div class="prod_title">AMADEO APP SERVICES</div>
                    <div class="prod_subtitle">amadeo app store</div>
                </div>
            </a>
        </div>
        <div class="product_item">
            <a (click)="routeToAOS()">
                <div style="padding:0;margin:0">
                    <div class="img_container aos">
                        <img src="../../../assets/aos.png" alt="AOS" class="product_img">
                    </div>
                </div>
                <div>
                    <div class="prod_title">AOS</div>
                    <div class="prod_subtitle">AOS</div>
                </div>
            </a>
        </div>
    </div>
</div>